export default "__VITE_ASSET__tbhqF7fs__"